import { callApi } from "./ApiClient";

const getNotifications = (data, dispatch) => {
  return callApi("GET", "/notifications", data, dispatch);
};

const postNotificationsMark = (id, data, dispatch) => {
  return callApi("POST", `/notifications/${id}/mark`, data, dispatch);
};

export const NotificationInfosApi = {
  getNotifications,
  postNotificationsMark,
};



// WEBPACK FOOTER //
// ./src/redux/api/NotificationInfosApi.js